document.addEventListener("DOMContentLoaded", () => {
  const data = {
    address: null,
  };

  window.coverageCheckerData = data;

  const coverageChecker = document.getElementById('coverage-checker');
  const coverageCheckerCloseButton = document.getElementById('coverage-checker-close-button');
  const coverageCheckerTriggers = document.querySelectorAll('.coverage-checker-trigger');

  if (coverageCheckerCloseButton) coverageCheckerCloseButton.addEventListener('click', () => closeCoverageChecker(data))
  coverageChecker.addEventListener('click', (e) => e.stopPropagation());

  coverageCheckerTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      showCoverageCheckerPopup(data);
      showCoverageCheckerStep1(data);
    });
  });

  const coverageCheckerPopup = document.getElementById('coverage-checker-popup');

  if (coverageCheckerPopup) coverageCheckerPopup.addEventListener('click', () => closeCoverageChecker(data));

  initializeChargebeeProductTracking('cb-residential-standard-cc', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'coverageCheckerCHECKOUT')
  initializeChargebeeProductTracking('cb-residential-advanced-cc', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'coverageCheckerCHECKOUT')
  initializeChargebeeProductTracking('cb-travel-standard-cc', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'coverageCheckerCHECKOUT')
  initializeChargebeeProductTracking('cb-travel-advanced-cc', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'coverageCheckerCHECKOUT')
  initializeChargebeeProductTracking('cb-residential-standard-with-coupon', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-residential-advanced-with-coupon', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-travel-standard-with-coupon', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-travel-advanced-with-coupon', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-residential-standard-with-coupon-15', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-residential-advanced-with-coupon-15', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-travel-standard-with-coupon-15', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-travel-advanced-with-coupon-15', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'CONNECT15')
});

const openCoverageChecker = () => {
  const coverageChecker = document.getElementById('coverage-checker');
  const coverageCheckerError = document.getElementById('coverage-checker-error');
  const coverageCheckerErrorMessage = document.getElementById('coverage-checker-error-message');

  coverageCheckerError.style.display = 'none';
  coverageCheckerErrorMessage.innerText = 'An error occurred';
  coverageChecker.style.display = 'flex';
}

const closeCoverageChecker = (data) => {
  const coverageChecker = document.getElementById('coverage-checker');
  coverageChecker.style.display = 'none';

  window.coverageCheckerData.type = window.coverageCheckerData.previousType;
  hideCoverageCheckerPopup(data);
}

const showCoverageCheckerStep1 = (data) => {
  const coverageCheckerStep1 = document.getElementById('coverage-checker-step-1');
  const coverageCheckerStep2 = document.getElementById('coverage-checker-step-2');
  const coverageCheckerStep3 = document.getElementById('coverage-checker-step-3');

  coverageCheckerStep3.style.display = 'none';
  coverageCheckerStep2.style.display = 'none';
  coverageCheckerStep1.style.display = 'flex';

  data.currentStep = 1;

  const coverageCheckerProgressBarStep1 = document.getElementById('coverage-checker-progress-bar-fill-1');
  const coverageCheckerProgressBarStep2 = document.getElementById('coverage-checker-progress-bar-fill-2');

  coverageCheckerProgressBarStep1.style.width = '0%';
  coverageCheckerProgressBarStep2.style.width = '0%';

  const coverageCheckerProgressText = document.getElementById('coverage-checker-progress-text');
  coverageCheckerProgressText.innerText = 'Step 1 of 2';
  coverageCheckerProgressText.style.display = 'block';

  const coverageCheckerProgress = document.getElementById('coverage-checker-progress');
  coverageCheckerProgress.style.display = 'flex';

  const coverageCheckerMainHeading1 = document.getElementById('coverage-checker-heading-1');
  const coverageCheckerMainHeading2 = document.getElementById('coverage-checker-heading-2');

  coverageCheckerMainHeading1.style.display = 'flex';
  coverageCheckerMainHeading2.style.display = 'none';

  const coverageChecker = document.getElementById('coverage-checker');
  coverageChecker.scrollTo(0, 0);

  let coverageCheckerStep1Submit = document.getElementById('coverage-checker-step-1-submit');
  const coverageCheckerError = document.getElementById('coverage-checker-error');
  const coverageCheckerErrorMessage = document.getElementById('coverage-checker-error-message');

  const coverageCheckerStep1SubmitEventHandler = async (e) => {
    e.preventDefault();

    const zipInput = document.getElementById('coverage-checker-step-1-zip');

    coverageCheckerError.style.display = 'none';
    coverageCheckerErrorMessage.innerText = 'An error occurred';

    data.zipCode = zipInput.value.trim();

    coverageCheckerStep1Submit.innerHTML = '<div class="bar-loader"></div>';
    coverageCheckerStep1Submit.disabled = true;

    const coverageCheckResult = await checkCoverage(data.zipCode);

    if (coverageCheckResult) {
      data.address = coverageCheckResult;
      showCoverageCheckerStep2(data);
    }

    coverageCheckerStep1Submit.innerHTML = 'CHECK MY COVERAGE';
    coverageCheckerStep1Submit.disabled = false;
  }

  const coverageCheckerButtonContainer = document.getElementById('coverage-checker-button-container-main-step-1');

  const buttonClone = coverageCheckerStep1Submit.cloneNode(true);
  coverageCheckerButtonContainer.innerHTML = '';
  coverageCheckerButtonContainer.appendChild(buttonClone);

  coverageCheckerStep1Submit = document.getElementById('coverage-checker-step-1-submit');

  coverageCheckerStep1Submit.addEventListener('click', coverageCheckerStep1SubmitEventHandler, true);
}

const showCoverageCheckerStep2 = (data) => {
  const coverageCheckerStep1 = document.getElementById('coverage-checker-step-1');
  const coverageCheckerStep2 = document.getElementById('coverage-checker-step-2');
  const coverageCheckerStep3 = document.getElementById('coverage-checker-step-3');

  coverageCheckerStep3.style.display = 'none';
  coverageCheckerStep2.style.display = 'flex';
  coverageCheckerStep1.style.display = 'none';

  if (data.type == 'section') {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 2;

  const coverageCheckerProgressBarStep1 = document.getElementById('coverage-checker-progress-bar-fill-1');
  const coverageCheckerProgressBarStep2 = document.getElementById('coverage-checker-progress-bar-fill-2');

  coverageCheckerProgressBarStep1.style.width = '100%';
  coverageCheckerProgressBarStep2.style.width = '0%';

  const coverageCheckerProgressText = document.getElementById('coverage-checker-progress-text');
  coverageCheckerProgressText.innerText = 'Step 2 of 2';
  coverageCheckerProgressText.style.display = 'block';

  const coverageCheckerProgress = document.getElementById('coverage-checker-progress');
  coverageCheckerProgress.style.display = 'flex';

  const coverageCheckerMainHeading1 = document.getElementById('coverage-checker-heading-1');
  const coverageCheckerMainHeading2 = document.getElementById('coverage-checker-heading-2');

  coverageCheckerMainHeading1.style.display = 'none';
  coverageCheckerMainHeading2.style.display = 'flex';

  const coverageCheckerStep2AddressText = document.getElementById('coverage-checker-step-2-address-text');
  coverageCheckerStep2AddressText.innerText = data.address;

  let coverageCheckerStep2Submit = document.getElementById('coverage-checker-step-2-submit');
  const coverageCheckerError = document.getElementById('coverage-checker-error');
  const coverageCheckerErrorMessage = document.getElementById('coverage-checker-error-message');
  const phoneInput = document.getElementById('coverage-checker-step-2-phone');

  phoneInput.addEventListener('keypress', (e) => {
    if (e.keyCode > 47 && e.keyCode < 58) {
      setTimeout(() => {
        let inputValue = e.target.value.replace(/\D/g, '');
        let inputStr = e.target.value;

        if (inputValue.length == 0) {
          inputStr = inputStr;
        } else if (inputValue.length < 4) {
          inputValue = '(' + inputValue;
        } else if (inputValue.length < 7) {
          inputValue = '(' + inputValue.substring(0, 3) + ') ' + inputValue.substring(3, 6);
        } else {
          inputValue =
            '(' + inputValue.substring(0, 3) + ') ' + inputValue.substring(3, 6) + '-' + inputValue.substring(6, 10);
        }

        e.target.value = inputValue;
      }, 100);
    } else {
      e.preventDefault();
    }
  })

  const coverageCheckerStep2SubmitEventHandler = async (e) => {
    e.preventDefault();

    const firstNameInput = document.getElementById('coverage-checker-step-2-first-name');
    const lastNameInput = document.getElementById('coverage-checker-step-2-last-name');

    coverageCheckerError.style.display = 'none';
    coverageCheckerErrorMessage.innerText = 'An error occurred';

    data.phone = phoneInput.value.trim();
    data.firstName = firstNameInput.value.trim();
    data.lastName = lastNameInput.value.trim();

    if (data.firstName === '') {
      coverageCheckerErrorMessage.innerText = 'Please input first name'
      coverageCheckerError.style.display = 'flex';
      coverageCheckerError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    if (data.lastName === '') {
      coverageCheckerErrorMessage.innerText = 'Please input last name'
      coverageCheckerError.style.display = 'flex';
      coverageCheckerError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    if (data.phone.length < 10) {
      coverageCheckerErrorMessage.innerText = 'Please input a valid phone number'
      coverageCheckerError.style.display = 'flex';
      coverageCheckerError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    let payload = {
      phone: data.phone,
      first_name: data.firstName,
      last_name: data.lastName,
      address: data.address,
      source: 'Popup',
      timestamp: new Date().toISOString(),
    };

    coverageCheckerStep2Submit.innerHTML = '<div class="bar-loader"></div>';
    coverageCheckerStep2Submit.disabled = true;

    try {
      let r = await fetch('https://app.lrlos.com/webhook/address-lookup', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error('Error:', error);
      return;
    } finally {
      coverageCheckerStep2Submit.innerHTML = 'SEE WHAT I QUALIFY FOR';
      coverageCheckerStep2Submit.disabled = false;
    }

    showCoverageCheckerStep3(data);
  }

  const coverageCheckerButtonContainer = document.getElementById('coverage-checker-button-container-main-step-2');

  const buttonClone = coverageCheckerStep2Submit.cloneNode(true);
  coverageCheckerButtonContainer.innerHTML = '';
  coverageCheckerButtonContainer.appendChild(buttonClone);

  coverageCheckerStep2Submit = document.getElementById('coverage-checker-step-2-submit');

  coverageCheckerStep2Submit.addEventListener('click', coverageCheckerStep2SubmitEventHandler, true);
}

const showCoverageCheckerStep3 = (data) => {
  const coverageCheckerStep1 = document.getElementById('coverage-checker-step-1');
  const coverageCheckerStep2 = document.getElementById('coverage-checker-step-2');
  const coverageCheckerStep3 = document.getElementById('coverage-checker-step-3');

  coverageCheckerStep3.style.display = 'flex';
  coverageCheckerStep2.style.display = 'none';
  coverageCheckerStep1.style.display = 'none';

  if (data.type == 'section') {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 3;

  const coverageCheckerProgress = document.getElementById('coverage-checker-progress');
  coverageCheckerProgress.style.display = 'none';

  const coverageCheckerMainHeading1 = document.getElementById('coverage-checker-heading-1');
  const coverageCheckerMainHeading2 = document.getElementById('coverage-checker-heading-2');

  coverageCheckerMainHeading1.style.display = 'none';
  coverageCheckerMainHeading2.style.display = 'none';

  const coverageCheckerStep3AddressText = document.getElementById('coverage-checker-step-3-address-text');
  coverageCheckerStep3AddressText.innerText = data.address;

  const coverageCheckerStep3TitleText = document.getElementById('coverage-checker-step-3-title-text');
  if (data.title) {
    coverageCheckerStep3TitleText.innerText = data.title;
  } else {
    coverageCheckerStep3TitleText.innerText = 'Congratulations, Nomad Internet is Available in Your Area.';
  }

  const coverageCheckerStep3SubtitleText = document.getElementById('coverage-checker-step-3-subtitle-text');

  if (data.subtitle) {
    coverageCheckerStep3SubtitleText.innerText = data.subtitle;
  } else {
    coverageCheckerStep3SubtitleText.innerText = 'Great news! You can now proceed to choose your modem and plan that fit your needs.';
  }

  const coverageCheckerStep3Submit = document.getElementById('coverage-checker-step-3-submit');
  if (data.buttonText) {
    coverageCheckerStep3Submit.innerText = data.buttonText;
  } else {
    coverageCheckerStep3Submit.innerText = 'VIEW PLANS';
  }

  const coverageCheckerStep3FooterText = document.getElementById('coverage-checker-step-3-footer-text');
  if (data.footerText) {
    coverageCheckerStep3FooterText.innerText = data.footerText;
    coverageCheckerStep3FooterText.style.display = 'block';
  } else {
    coverageCheckerStep3FooterText.style.display = 'none';
  }

  const coverageCheckerPopupMain = document.getElementById('coverage-checker');
  coverageCheckerPopupMain.scrollTo(0, 0);
}

const checkCoverage = async(address) => {
  if (address.length < 5) {
    Toastify({
      text: "Please enter a valid zip code or address",
      duration: 3000,
      newWindow: true,
      gravity: "top",
      position: "center",
      style: {
        background: 'red',
        color: 'white'
      },
    }).showToast();

    return;
  }

  try {
    let response = await fetch(
      `https://photon.komoot.io/api/?q=${address}&countrycode=US`,
      {
        method: 'GET',
      }
    );

    if (!response.ok) {
      Toastify({
        text: "An error occurred while checking coverage. Please try again later.",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      return;
    }

    const data = await response.json();

    if (!data.features || data.features.length === 0) {
      Toastify({
        text: "Invalid address or zip code. Please try again",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
        style: {
          background: 'red',
          color: 'white'
        },
      }).showToast();

      return;
    }

    const city = data.features[0].properties.city || '';
    const county = data.features[0].properties.county || '';
    const state = data.features[0].properties.state || '';

    const addressContent = [city, county, state].join.call([city, county, state].filter(Boolean), ', ');

    return addressContent;
  } catch (error) {
    return null;
  }
}
